import { render, staticRenderFns } from "./shujutongji.vue?vue&type=template&id=3dfc8216&scoped=true&"
import script from "./shujutongji.vue?vue&type=script&lang=js&"
export * from "./shujutongji.vue?vue&type=script&lang=js&"
import style0 from "./shujutongji.vue?vue&type=style&index=0&id=3dfc8216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfc8216",
  null
  
)

export default component.exports